import React from 'react';
import PropTypes from 'prop-types';

import { StructuredTextPropTypes } from 'dpl/prismic/utils/customPropTypes';
import RichText from 'dpl/prismic/components/RichText';

import { ARTICLE_CONTENT_COL_CLASSES } from '../utils/constants';

export default function Content({ sliceData }) {
  return (
    <div className="PrismicContent container">
      <div className="row">
        <div className={ARTICLE_CONTENT_COL_CLASSES}>
          <RichText content={sliceData.primary.content} />
        </div>
      </div>
    </div>
  );
}

Content.propTypes = {
  sliceData: PropTypes.shape({
    primary: PropTypes.shape({
      content: StructuredTextPropTypes.isRequired
    }).isRequired
  }).isRequired
};
